import { useAnalytics } from "@codat/analytics";
import { Modal, TextInput, useToast } from "@codat/orchard-ui";
import React, { useState } from "react";

import { useAddApiKey } from "../api";
import styles from "./CreateApiKeyModal.module.scss";

export interface CreateApiKeyModalProps {
  onClose: () => void;
  onCreated: () => void;
}

export const CreateApiKeyModal: React.FC<CreateApiKeyModalProps> = (props) => {
  const { onClose, onCreated } = props;
  const { addToast } = useToast();
  const { sendEvent } = useAnalytics();
  const [keyName, setKeyName] = useState("");

  const [{ loading: addLoading }, addApiKey] = useAddApiKey();

  const onCreateClick = () => {
    const data = keyName ? { name: keyName } : undefined;

    addApiKey({ data })
      .then(() => {
        onCreated();
      })
      .catch(() => {
        addToast({
          variant: "error",
          message: "Error creating new API key",
          subText: "Please try again",
        });
      });
  };

  return (
    <Modal onClose={onClose} size="small" data-testid="create-api-key-modal">
      <>
        <Modal.Header onClose={onClose} title="Create API key" />
        <Modal.Body variant="light">
          <TextInput
            className={styles.input}
            label="Name"
            placeholder="API key"
            value={keyName}
            onChange={(e) => setKeyName(e.target.value)}
            maxLength={50}
            showCharacterCount
            data-autofocus
            data-testid="key-name-input"
          />
        </Modal.Body>
        <Modal.Footer
          variant="dark"
          buttons={[
            {
              label: "Cancel",
              variant: "secondary",
              color: "interface",
              onClick: onClose,
            },
            {
              label: "Create API key",
              variant: "primary",
              color: "action",
              onClick: () => {
                sendEvent("Create API key button - Click");
                onCreateClick();
              },
              isLoading: addLoading,
              "data-testid": "create-api-key-modal-button",
            },
          ]}
        />
      </>
    </Modal>
  );
};
